/*
 * @Author: cc
 * @LastEditTime: 2021-06-09 10:58:44
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'antd/dist/antd.css'
import './App.css'
import App from './route/index'
import { Provider } from 'react-redux'
import store from './reducers/index'
import { StyleProvider } from '@ant-design/cssinjs';
ReactDOM.render(
  <Provider store={store}>
    <StyleProvider hashPriority="high">
      <App />
    </StyleProvider>
  </Provider>,
  document.getElementById('root')
);